// Prevent multiple declarations of the same script
if (!window.GradientOverlayManager) {
  // Global registry to track instances and prevent duplicates
  window.GradientOverlayManager = {
    instances: new Map(),
    initialized: false,
  };

  class GradientOverlay {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.slider = document.querySelector(`#Slider-${sectionId}`);
      this.leftGradient = document.querySelector(
        `.gradient-overlay-left-${sectionId}`
      );
      this.rightGradient = document.querySelector(
        `.gradient-overlay-right-${sectionId}`
      );

      if (!this.slider || !this.leftGradient || !this.rightGradient) {
        return;
      }

      this.init();
    }

    init() {
      // Initial check
      this.updateGradients();

      // Add scroll event listener
      this.slider.addEventListener("scroll", () => {
        this.updateGradients();
      });

      // Add resize event listener to recalculate on window resize
      this.resizeHandler = () => {
        this.updateGradients();
      };
      window.addEventListener("resize", this.resizeHandler);

      // Watch for slider changes (for touch/swipe interactions)
      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updateGradients();
        });
        this.resizeObserver.observe(this.slider);
      }
    }

    updateGradients() {
      const scrollLeft = this.slider.scrollLeft;
      const scrollWidth = this.slider.scrollWidth;
      const clientWidth = this.slider.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      // Show/hide left gradient
      if (scrollLeft <= 5) {
        // Small threshold to account for rounding
        this.leftGradient.style.opacity = "0";
      } else {
        this.leftGradient.style.opacity = "1";
      }

      // Show/hide right gradient
      if (scrollLeft >= maxScroll - 5) {
        // Small threshold to account for rounding
        this.rightGradient.style.opacity = "0";
      } else {
        this.rightGradient.style.opacity = "1";
      }
    }

    // Cleanup method to remove event listeners
    destroy() {
      if (this.resizeHandler) {
        window.removeEventListener("resize", this.resizeHandler);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }

  // Function to initialize a gradient overlay for a specific section
  function initGradientOverlay(sectionId) {
    const manager = window.GradientOverlayManager;

    // Check if instance already exists for this section
    if (manager.instances.has(sectionId)) {
      return;
    }

    // Check if the section actually has gradient overlays
    const wrapper = document.querySelector(`.slider-wrapper-${sectionId}`);
    if (!wrapper) {
      return;
    }

    // Create new instance and store it
    const instance = new GradientOverlay(sectionId);
    if (instance.slider) {
      // Only store if successfully initialized
      manager.instances.set(sectionId, instance);
    }
  }

  // Function to remove a gradient overlay instance
  function removeGradientOverlay(sectionId) {
    const manager = window.GradientOverlayManager;
    const instance = manager.instances.get(sectionId);

    if (instance) {
      instance.destroy();
      manager.instances.delete(sectionId);
    }
  }

  // Initialize all gradient overlays on the page
  function initAllGradientOverlays() {
    const gradientWrappers = document.querySelectorAll(
      '[class*="slider-wrapper-"]'
    );

    gradientWrappers.forEach((wrapper) => {
      // Extract section ID from class name
      const classList = Array.from(wrapper.classList);
      const wrapperClass = classList.find((cls) =>
        cls.startsWith("slider-wrapper-")
      );

      if (wrapperClass) {
        const sectionId = wrapperClass.replace("slider-wrapper-", "");
        initGradientOverlay(sectionId);
      }
    });
  }

  // Initialize gradient overlays when DOM is loaded (only once)
  if (!window.GradientOverlayManager.initialized) {
    document.addEventListener("DOMContentLoaded", () => {
      initAllGradientOverlays();
    });

    // Handle theme section loads (for theme editor)
    document.addEventListener("shopify:section:load", (event) => {
      const sectionId = event.detail.sectionId;
      initGradientOverlay(sectionId);
    });

    // Handle theme section unloads (cleanup)
    document.addEventListener("shopify:section:unload", (event) => {
      const sectionId = event.detail.sectionId;
      removeGradientOverlay(sectionId);
    });

    window.GradientOverlayManager.initialized = true;
  }
} // End of GradientOverlayManager check
